if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }
	  show(opener) {
		opener.setAttribute('aria-disabled', true);
		opener.classList.add('loading');
		opener.querySelector('.loading__spinner').classList.remove('hidden');
	
		fetch(opener.getAttribute('data-product-url'))
		  .then((response) => response.text())
		  .then((responseText) => {
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
			if (!this.productElement) {
			  throw new Error("Product element not found in the fetched HTML.");
			}
	
			this.productElement.classList.forEach((classApplied) => {
			  if (classApplied.startsWith('color-') || classApplied === 'gradient')
				this.modalContent.classList.add(classApplied);
			});
			this.preventDuplicatedIDs();
			this.removeDOMElements();
			this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
			this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
			if (this.cart ) {
			  const addButton = this.modalContent.querySelector('.cart-drawer-quick-add .add-to-bag-product-button-be');
			  if (addButton) {
				const index = opener.getAttribute('index');
				addButton.addEventListener('click', async (event) => {
				  event.preventDefault()
				  const removeButton = document.querySelector(`#CartDrawer-Remove-${index}`);
				  if (removeButton) {
					removeButton.querySelector('button').click();
					const checkCartUpdated = () => {
					  return new Promise((resolve) => {
						const interval = setInterval(async () => {
						  const cartResponse = await fetch('/cart.js');
						  const cartData = await cartResponse.json();
						  if (!cartData.items.find(item => item.variant_id === parseInt(opener.getAttribute('data-variant-id')))) {
							clearInterval(interval);
							resolve();
						  }
						}, 500);
					  });
					};
					await checkCartUpdated();
					const config = fetchConfig('javascript');
					config.headers['X-Requested-With'] = 'XMLHttpRequest';
					delete config.headers['Content-Type'];
					const form = this.modalContent.querySelector('form');
					const formData = new FormData(form);
					if (this.cart) {
						formData.append(
						  'sections',
						  this.cart.getSectionsToRender().map((section) => section.id)
						);
						formData.append('sections_url', window.location.pathname);
						this.cart.setActiveElement(document.activeElement);
					  }
					  config.body = formData;
	
					  fetch(`${routes.cart_add_url}`, config)
					  .then((response) => response.json())
					  .then((response) => {
						if (response.status) {
						  publish(PUB_SUB_EVENTS.cartError, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							errors: response.errors || response.description,
							message: response.message,
						  });
						  this.handleErrorMessage(response.description);
			
						  const soldOutMessage = this.addButton.querySelector('.sold-out-message');
						  if (!soldOutMessage) return;
						  addButton.setAttribute('aria-disabled', true);
						  addButton.querySelector('span').classList.add('hidden');
						  soldOutMessage.classList.remove('hidden');
						  this.error = true;
						  return;
						} else if (!this.cart) {
						  window.location = window.routes.cart_url;
						  return;
						}
						if (!this.error)
						  publish(PUB_SUB_EVENTS.cartUpdate, {
							source: 'cart-items',
							productVariantId: formData.get('id'),
							cartData: response,
						  });
						this.error = false;
						const quickAddModal = this.closest('quick-add-modal');
						if (quickAddModal) {
						  document.body.addEventListener(
							'modalClosed',
							() => {
							  setTimeout(() => {
								this.cart.renderContents(response);
							  });
							},
							{ once: true }
						  );
						  quickAddModal.hide(true);
						} else {
						  this.cart.renderContents(response);
						}
					})
					.catch((e) => {
					  console.error(e);
					})
					.finally(() => {
						addButton.classList.remove('loading');
					  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
					  if (!this.error) addButton.removeAttribute('aria-disabled');
					  opener.querySelector('.loading__spinner').classList.add('hidden');
					});
					this.hide();
				  }
				});
			  }
			}

			if (window.Shopify && Shopify.PaymentButton) {
			  Shopify.PaymentButton.init();
			}
	
			if (window.ProductModel) window.ProductModel.loadShopifyXR();
			this.removeGalleryListSemantic();
			this.updateImageSizes();
			super.show(opener);
		  })
		  .catch(error => {
			console.error('Error loading product information:', error);
		  })
		  .finally(() => {
			opener.removeAttribute('aria-disabled');
			opener.classList.remove('loading');
			opener.querySelector('.loading__spinner').classList.add('hidden');
		  });
	  }
	

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        if (sectionId) {
          this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
          this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
            element.dataset.originalSection = sectionId;
          });
        }
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
